import {ReactNode} from 'react';
import useTypedSelector from '../../../../common/useTypedSelector';
import {
  ContentCheckFreeTicket,
  Maybe,
} from '../../../../graphql/generated/types';

export function ContentFreeTicketCheckerHeadless({
  seriesId,
  contentCheckFreeTicket,
  children,
}: {
  seriesId: number;
  contentCheckFreeTicket: Maybe<ContentCheckFreeTicket>;
  children: ReactNode;
}) {
  const {isReceived} = useTypedSelector(state => ({
    isReceived: !!state.ticket?.receivedFreeTicket?.[seriesId],
  }));

  // 무료 이용권이 없는 경우와 이미 받은 경우 children 을 보여주지 않는다
  if (
    !contentCheckFreeTicket ||
    !contentCheckFreeTicket.list.length ||
    isReceived
  ) {
    return null;
  }

  return <>{children}</>;
}
